<template>
  <customModal
    :containersm="true"
    :footerShow="true"
    class="document-sign-confirm-modal"
    @closeModal="$emit('close')"
  >
    <template #title>
      <span>Confirm Your Signature</span>
    </template>

    <template #body>
      <div class="sign-summary mb-3 p-3 bg-light rounded border">
        <p class="font-weight-bold mb-1 text-primary small text-uppercase">
          You are about to sign:
        </p>
        <ul class="mb-0 pl-3 small text-dark">
          <li v-for="f in fields" :key="f.signatureKey">
            <strong>{{ f.displayName }}</strong> (Signing Order
            {{ f.signingOrder }})
          </li>
        </ul>
      </div>

      <div v-if="error" class="alert alert-danger py-2 px-3 mb-3 small">
        {{ error }}
      </div>

      <div class="form-group mb-3">
        <label for="inputEmail" class="font-weight-bold mb-1 small"
          >Email</label
        >
        <input
          type="email"
          id="inputEmail"
          class="form-control form-control-sm"
          :value="email"
          readonly
        />
      </div>

      <div class="form-group mb-3">
        <label for="inputUsername" class="font-weight-bold mb-1 small"
          >Username <span class="text-danger">*</span></label
        >
        <input
          type="text"
          id="inputUsername"
          class="form-control form-control-sm"
          v-model="username"
          placeholder="Enter your username"
          :disabled="saving"
        />
      </div>

      <div class="form-group mb-3">
        <label for="inputPassword" class="font-weight-bold mb-1 small"
          >Password <span class="text-danger">*</span></label
        >
        <div class="input-group input-group-sm">
          <input
            :type="showPassword ? 'text' : 'password'"
            id="inputPassword"
            class="form-control form-control-sm"
            v-model="password"
            placeholder="Enter your password"
            :disabled="saving"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              :disabled="saving"
              @click="showPassword = !showPassword"
            >
              <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="form-check mb-2">
        <input
          type="checkbox"
          id="consentCheck"
          class="form-check-input"
          v-model="consent"
          :disabled="saving"
        />
        <label for="consentCheck" class="form-check-label text-secondary small">
          I confirm that my electronic signature is legally binding and carries
          the same effect as my handwritten signature.
        </label>
      </div>
    </template>

    <template #footer>
      <div class="d-flex justify-content-end align-items-center w-100">
        <button
          type="button"
          class="btn btn-secondary btn-sm mr-2"
          :disabled="saving"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          :disabled="saving"
          @click="confirmSign"
        >
          {{ saving ? "Signing…" : "Sign" }}
        </button>
      </div>
    </template>
  </customModal>
</template>

<script>
import customModal from "../customModal/customModal.vue";
import store from "../../store/index";
import { jwtDecrypt } from "../../Shared/jwtHelper";

export default {
  name: "documentSignPopup",
  components: { customModal },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    email: {
      type: String,
      default: "",
    },
    saving: {
      type: Boolean,
      default: false,
    },
    serverError: {
      type: String,
      default: "",
    },
  },
  emits: ["close", "confirm"],
  data() {
    return {
      username: "",
      password: "",
      consent: false,
      showPassword: false,
      localError: "",
    };
  },
  computed: {
    error() {
      return this.localError || this.serverError;
    },
  },
  watch: {
    fields() {
      this.password = "";
      this.consent = false;
      this.showPassword = false;
      this.localError = "";
    },
  },
  methods: {
    confirmSign() {
      if (this.saving) return;
      if (!this.username.trim() || !this.password) {
        this.localError = "Enter your username and password to continue.";
        return;
      }
      if (!this.consent) {
        this.localError =
          "Agree to the electronic signature terms to continue.";
        return;
      }
      this.localError = "";
      this.$emit("confirm", {
        username: this.username.trim(),
        password: this.password,
      });
    },
  },
};
</script>

<style scoped>
::v-deep .iframe-wrapper {
  z-index: 10050 !important;
}
.sign-summary {
  background-color: #f8f9fa;
  font-size: 13.5px;
}
.btn-primary {
  background-color: #0069d9;
  border-color: #0062cc;
  color: #ffffff !important;
}
.btn-primary:hover,
.btn-primary:focus {
  background-color: #0069d9;
  border-color: #0062cc;
}
.btn-primary:disabled {
  background-color: #a7dfd3 !important;
  border-color: #a7dfd3 !important;
  opacity: 0.7;
}
</style>